// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dot[data-v-3f7a0a40] {\n  background-color: #ff7058;\n  -webkit-box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.1607843137);\n          box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.1607843137);\n  margin: 2px;\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  border-style: solid;\n  border-width: 3px;\n  border-color: #fff;\n  display: inline-block;\n}\n.orange-icon-badge-align[data-v-3f7a0a40] {\n  vertical-align: top;\n}", ""]);
// Exports
module.exports = exports;
